var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_303_401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5187 3.99285C20.0138 3.68535 9.98 3.6866 5.48125 3.99285C0.61 4.32535 0.03625 7.26785 0 15.0129C0.03625 22.7441 0.605 25.6991 5.48125 26.0329C9.98125 26.3391 20.0138 26.3404 24.5187 26.0329C29.39 25.7004 29.9638 22.7579 30 15.0129C29.9638 7.2816 29.395 4.3266 24.5187 3.99285ZM11.25 20.0129V10.0129L21.25 15.0041L11.25 20.0129Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.33ddd47a7d0a529bc8a0d7ae0ba6a97e.svg";
export { ForwardRef as ReactComponent };